import { useMemo } from "react";

export const COUNTRY_CODES = ["+91", "+1", "+44", "+971", "+61", "+65", "+81", "+49", "+33", "+86", "+880", "+977", "+94"];

export function splitPhone(value) {
  const v = (value || "").trim();
  if (v.startsWith("+")) {
    const compact = v.replace(/[^\d+]/g, "");
    for (const c of COUNTRY_CODES) {
      if (compact.startsWith(c)) return { code: c, number: compact.slice(c.length) };
    }
    const m = compact.match(/^\+(\d{1,3})(\d*)$/);
    return { code: m ? `+${m[1]}` : "+91", number: m ? m[2] : "" };
  }
  return { code: "+91", number: v.replace(/\D/g, "") };
}

export default function PhoneInput({ value, onChange, id, testid, required, placeholder = "98765 43210", inputCls = "", selectCls = "", wrapperCls = "" }) {
  const { code, number } = useMemo(() => splitPhone(value), [value]);
  const emit = (c, n) => {
    const digits = (n || "").replace(/\D/g, "");
    onChange(digits ? `${c}${digits}` : "");
  };
  return (
    <div className={`flex items-stretch ${wrapperCls}`}>
      <select value={code} onChange={(e) => emit(e.target.value, number)} aria-label="Country code"
        data-testid={testid ? `${testid}-code` : undefined}
        className={`shrink-0 rounded-l-xl border border-r-0 border-slate-300 bg-slate-50 text-sm font-bold text-slate-700 pl-3 pr-2 outline-none cursor-pointer ${selectCls}`}>
        {COUNTRY_CODES.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <input id={id} type="tel" inputMode="tel" required={required} value={number}
        onChange={(e) => emit(code, e.target.value)}
        placeholder={placeholder}
        className={`${inputCls} !rounded-l-none`}
        data-testid={testid} />
    </div>
  );
}
